import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../../util/FirebaseConfig";

/**
 * Firebase App Initialization
 *
 * This file initializes the Firebase app instance that can be shared
 * across all Firebase services (Storage, Messaging, etc.)
 */

// Initialize Firebase app
const firebaseApp = initializeApp(firebaseConfig);

// Export the app instance
export { firebaseApp };

/**
 * Usage:
 *
 * import { firebaseApp } from './firebaseApp';
 *
 * const storage = getStorage(firebaseApp);
 * const messaging = getMessaging(firebaseApp);
 */
